// extracted by mini-css-extract-plugin
module.exports = {"layout":"DayTabContainer_layout__Yo3S0"};